module.exports = __webpack_public_path__ + "img/cl.15c14817.svg";